export const SET_DEVICES_INFORMATION = 'SET_DEVICES_INFORMATION';

export const setDevicesInformation = (devicesInformation) => ({
  type: SET_DEVICES_INFORMATION,
  devicesInformation
});
